/* UNINSPIRED LP — top social proof pill
   Hardcoded names/cities/verbs. No product nouns. Rotates every 8s. */
(function () {
  var proof = document.getElementById('lpTopProof');
  var text = document.getElementById('lpProofText');
  if (!proof || !text) return;

  var minViewer = parseInt(proof.dataset.minViewer, 10) || 8;
  var maxViewer = parseInt(proof.dataset.maxViewer, 10) || 22;
  var minOrders = parseInt(proof.dataset.minOrders, 10) || 4;
  var maxOrders = parseInt(proof.dataset.maxOrders, 10) || 11;

  var names = [
    'Maya','Jordan','Kai','Riley','Sam','Avery','Robin','Quinn','Reese','Skyler',
    'Harper','Rowan','Sage','Eden','River','Phoenix','Wren','Hayden','Emerson','Blake',
    'Alex','Charlie','Drew','Frankie','Jess','Lane','Morgan','Parker','Remy','Taylor',
    'Casey','Devon','Ellis','Finley','Gray','Indigo','Jules','Kennedy','Logan','Marlowe',
    'Nico','Oakley','Paris','Quincy','Rae','Sasha','Toby','Val','Winter','Zion',
    'Ari','Bex','Cam','Dani','Eli','Sloan','Tatum','Vin','Lex','Sky',
    'Theo','Cory','Bey','Andy','Mar','Pax','Sol','Lou','Cleo','Nev',
    'Toni','Bri','Cass','Jay','Rio'
  ];
  var cities = [
    'Brooklyn','Austin','Portland','Atlanta','LA','Denver','Chicago','Toronto','Nashville','Boston',
    'Seattle','Minneapolis','Philly','Phoenix','Dallas','Miami','Baltimore','Oakland','Detroit','DC',
    'Vancouver','Montreal','Calgary','Ottawa','Pittsburgh','St. Louis','New Orleans','Indianapolis','Columbus','Salt Lake City',
    'Charlotte','Tampa','Cleveland','Sacramento','Madison','Richmond','Albuquerque','Buffalo','Raleigh','Boise',
    'Spokane','Tucson','Reno','Omaha','Des Moines','Fargo','Hartford','Providence','Edmonton','Halifax'
  ];
  var verbs = [
    'just placed an order',
    'just checked out',
    'placed an order',
    'just got theirs',
    'just signed up',
    'just took the quiz',
    'just scanned theirs',
    'just unlocked theirs'
  ];

  function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function randInt(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }

  // 60% viewer count, 25% name+city action, 15% daily orders → encoded by frequency in this list
  var messages = [
    function () { return randInt(minViewer, maxViewer) + ' are looking right now'; },
    function () { return randInt(minViewer, maxViewer) + ' are looking right now'; },
    function () { return randInt(minViewer, maxViewer) + ' are looking right now'; },
    function () { return rand(names) + ' in ' + rand(cities) + ' ' + rand(verbs); },
    function () { return rand(names) + ' in ' + rand(cities) + ' ' + rand(verbs); },
    function () { return randInt(minOrders, maxOrders) + ' orders today'; }
  ];

  function shuffleStep(i) { return messages[i % messages.length](); }

  var i = 0;
  function rotate() {
    proof.classList.add('is-fading');
    setTimeout(function () {
      text.textContent = shuffleStep(i);
      i++;
      proof.classList.remove('is-fading');
    }, 350);
  }

  setTimeout(function () { text.textContent = shuffleStep(i); i++; }, 1500);
  setInterval(rotate, 8000);
})();
